import { Trans, useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import OptionCard from '../OptionCard/OptionCard'
import { discardAlertDefaultMessage } from './constants'

const DiscardOption = ({ selected, onClick, alertMessage }) => {
  const { t } = useTranslation()

  const defaultAlertMessage = <Trans i18nKey={discardAlertDefaultMessage} />

  return (
    <OptionCard
      selected={selected}
      onClick={onClick}
      alertType="warning"
      alertMessage={alertMessage || defaultAlertMessage}
    >
      <Text type="bodyMBold">{t('Descartar producto')}</Text>
    </OptionCard>
  )
}

export default DiscardOption
